/**
 * Storefront Hunter custom icons.
 *
 * ASSET_NOTE: Real Base64 PNG payloads are not in the repo yet.
 * Replace STOREFRONT_HUNTER_PNG_HREF and WINNING_PRODUCT_RADAR_PNG_HREF
 * with the supplied data:image/png;base64,... values when available.
 * Do not invent Base64 data.
 */

// Replace with supplied Storefront Hunter Base64 asset.
export const STOREFRONT_HUNTER_PNG_HREF = null;

// Replace with supplied Winning Product Radar Base64 asset.
export const WINNING_PRODUCT_RADAR_PNG_HREF = null;

function FallbackMark({ label }) {
  return (
    <g>
      <rect x="8%" y="8%" width="84%" height="84%" rx="12%" fill="#0A1728" />
      <circle cx="50%" cy="42%" r="18%" fill="none" stroke="#10B981" strokeWidth="3%" />
      <circle cx="50%" cy="42%" r="6%" fill="#10B981" />
      <text
        x="50%"
        y="78%"
        textAnchor="middle"
        fill="#F8FAFC"
        fontSize="9%"
        fontFamily="system-ui, sans-serif"
        fontWeight="600"
      >
        {label}
      </text>
    </g>
  );
}

/** 1254×1254 Storefront Hunter identity mark. */
export function StorefrontHunterIcon({ className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1254 1254"
      className={className}
      aria-hidden="true"
      role="img"
    >
      {STOREFRONT_HUNTER_PNG_HREF ? (
        <image
          x="0"
          y="0"
          width="1254"
          height="1254"
          preserveAspectRatio="xMidYMid meet"
          href={STOREFRONT_HUNTER_PNG_HREF}
        />
      ) : (
        <FallbackMark label="SFH" />
      )}
    </svg>
  );
}

/** 1462×1076 Winning Product Radar / floating control asset. */
export function WinningProductRadarIcon({ className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1462 1076"
      fill="none"
      className={className}
      aria-hidden="true"
      role="img"
    >
      {WINNING_PRODUCT_RADAR_PNG_HREF ? (
        <image
          x="0"
          y="0"
          width="1462"
          height="1076"
          preserveAspectRatio="xMidYMid meet"
          href={WINNING_PRODUCT_RADAR_PNG_HREF}
        />
      ) : (
        <g>
          <rect width="1462" height="1076" rx="80" fill="#0A1728" />
          <circle cx="731" cy="480" r="220" fill="none" stroke="#10B981" strokeWidth="28" opacity="0.35" />
          <circle cx="731" cy="480" r="140" fill="none" stroke="#10B981" strokeWidth="28" opacity="0.55" />
          <circle cx="731" cy="480" r="55" fill="#10B981" />
          <path d="M731 480 L1100 220" stroke="#10B981" strokeWidth="24" strokeLinecap="round" />
        </g>
      )}
    </svg>
  );
}

/** Storefront Hunter Filters funnel — do not use Lucide Filter here. */
export function FilterIcon({ className = "" }) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <path
        d="M4 5H20L14 12V18L10 20V12L4 5Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}
